import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import CustomizerReducer from "./customizer/CustomizerSlice";
import globalLoadingReducer from "./globalLoading/globalLoadingSlice";

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    globalLoading: globalLoadingReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

const rootReducer = combineReducers({
  customizer: CustomizerReducer,
  globalLoading: globalLoadingReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof rootReducer>;
